const ApiEndpoints = {
    login: "/auth/signin",
    resetPassword: "/auth/password-reset",
    verifyResetToken: "/auth/verify-reset-token/",
    setNewPassword: "/auth/password-reset/",
    sponsor: {
        base: "/api/sponsor",
        add: "/add",
        update: "/edit/", //=== /edit/id
        delete: "/delete/", //=== /delete/id
        addImage: "/api/sponsor/image_upload",
    },
    course: {
        base: "/api/course",
        add: "/add",
        update: "/edit/",
        delete: "/delete/",
        view: "/view/",
        getFrontBackCourses: "/get-front-and-back-nine-courses/",
        courseList: "/list",
        getParIndex: "/getcourseindexpar",
    },
    announcement: {
        base: "/api/announcement",
        add: "/add",
        update: "/edit/",
        delete: "/delete/",
    },
    news: {
        base: "/api/news",
        add: "/add",
        update: "/edit/",
        delete: "/delete/",
        updateImage: "/update_image/",
    },
    league: {
        base: "/api/league",
        add: "/add",
        update: "/update",
        delete: "/delete",
        pointSystem: "/pointsystem",
        listleaguePOTY: "/listleague/POTY",
        smp: "/getLatestLeage/SMP",
        addMatches: "/addPlayersInMatch",
        getGroupsTees: "/get-groups-and-tees",
        scoreEntry: "/smp-score-entry",
        getScore: "/getmatchscores",
        pointSystemUpdate: "/pointsystem/update",
        //listleaguePOTY: "/listleague/POTY",
        listleagueSMP: "/listleague/SMP",
        selectedLeague: "/getLeagueById",
        smpScoreManualBye: "/smp-score-entry-bye",
        dmpScoreManualBye: "/dmp-score-entry-bye",
    },
    season: {
        base: "/api/season",
    },
    player: {
        base: "/api/admin/users",
    },
    profile: {
        base: "/api/user",
        edit: "/edit-profile/",
        details: "/api/players/getPlayerDetails/",
    },
    allPlayers: {
        base: "/api/admin/players/listAllPlayers",
        player: "/api/players/listAllPlayers",
        delete: "/api/admin/players/delete/"
    },
    playerDetails: {
        base: "/api/admin/players/getPlayerDetails/",
    },
    minimalPlayers: {
        get: "/api/admin/users/players",
        player: "/api/players/listAllPlayers",
    },
    tournament: {
        base: "/api/tournament",
        poty: "/POTY",
        add: "/addPOTY",
        getPOTYDetails: "/details/",
        update: "/updatePlayers/",
        addDraws: "/addDraws/",
        sendDraws: "/send-draws/",
        getcombinedleaderboard: "/getcombinedleaderboard/",
        edit: "/POTY/update/",
        delete: "/POTY/",
        getAllPoty: "/api/league/listleague/POTY",
        getOnePoty: "/api/tournament/POTY/tournaments/",
        cx: "/api/tournament/POTY/getcombinedleaderboard/",
    },
    teams: {
        base: "/api/team",
        details: "/details/",
        all: "/list",
        add: "/add",
        edit: "/update/",
        delete: "/",
        getOne: "/api/team/",
        addImage: "/api/team/image_upload"
    },
    teamRanking: {
        league: "/api/tournament/POTY/league",
        leaderboard: "/team-leaderboard",
    },
    dashboard: {
        base: "/api",
        announcements: "/announcement",
        latest: "/latest",
    },
    user: {
        base: "/api/user",
        uploadImage: "/api/user/image_upload",
        playerHandicap: "/player-handicap-differentials",
        tournamentParticipation: "/tournament-participation/",
        addGuest: "/api/admin/users/addguest",
        calculateHandicap: "/api/admin/users/calculatehandicap",
        basicInfo: "/api/user/basic-info/",
    },
    users: {
        base: "/api/admin/users",
        edit: "/edit/",
    },
    leaguePlayers: {
        base: "/api/admin/users/players",
    },
    leaderboard: {
        base: "/api/tournament",
        getById: "/POTY/getallprojectedscores/",
        get: "/POTY/list",
        addScorecard: "/POTY/adminAddPlayerScores/",
    },
    dmpleague: {
        // base: "/api/league/getLatestLeage/DMP",
        base: "/api/league/listleague/DMP",
    },
    addPlayersInMatch: {
        base: "/api/league/addPlayersInMatchDmp",
    },
    dmpgetcourseindexpar: {
        base: "/api/course/getcourseindexpar/",
    },
    dmpgroupandtees: {
        base: "/api/league/get-dmp-tees",
    },
    // ApiEndpoints
};

export default ApiEndpoints;
